import { NgModule } from '@angular/core';
import { NoticeOfPrivacyPracticesRoutingModule } from './notice-of-privacy-practices.routing.module';
import { NoticeOfPrivacyPracticesComponent } from './notice-of-privacy-practices.component';
import { SharedModule } from '../shared/shared.module';
import { MaterialModule } from '../shared/material/material.module';

@NgModule({
	imports: [NoticeOfPrivacyPracticesRoutingModule, SharedModule, MaterialModule],
	declarations: [NoticeOfPrivacyPracticesComponent],
})
export class NoticeOfPrivacyPracticesModule {}
